import lazyWithRetry from '../../../utils/lazyWithRetry';

// The product screens the gallery and /tour show, each its own lazily loaded
// chunk (founder decision A, 2026-09-29: the screens come back below the
// fold, and the first screen must not pay for them). One registry, keyed by
// the panel keys in content/landingTour.js, so the two surfaces can never
// render different components for the same screen.
export const PANELS = {
    profile: lazyWithRetry(() => import('../v2/ProfileGlancePanel'), 'ProfileGlancePanel'),
    year: lazyWithRetry(() => import('../v2/PhaseJourneyPanel'), 'PhaseJourneyPanel'),
    read: lazyWithRetry(() => import('../v2/TheReadScene'), 'TheReadScene'),
    launchpad: lazyWithRetry(() => import('../v2/LaunchpadCardPanel'), 'LaunchpadCardPanel'),
    majors: lazyWithRetry(() => import('../v2/MajorConstellationPanel'), 'MajorConstellationPanel'),
    patent: lazyWithRetry(() => import('../v2/PatentLabPanel'), 'PatentLabPanel'),
    activities: lazyWithRetry(() => import('../v2/ActivityIdeasPanel'), 'ActivityIdeasPanel'),
    list: lazyWithRetry(() => import('../v2/ExplorerCardPanel'), 'ExplorerCardPanel'),
    summers: lazyWithRetry(() => import('../v2/SummerProgramPanel'), 'SummerProgramPanel'),
    outcomes: lazyWithRetry(() => import('../v2/OutcomesPanel'), 'OutcomesPanel'),
    essays: lazyWithRetry(() => import('../v2/EssayPanel'), 'EssayPanel'),
    roadmap: lazyWithRetry(() => import('../v2/RoadmapPanel'), 'RoadmapPanel'),
    astra: lazyWithRetry(() => import('../AstraReads'), 'AstraReads'),
    sharing: lazyWithRetry(() => import('../v2/SharePanel'), 'SharePanel'),
    agents: lazyWithRetry(() => import('../v2/AgentConnectPanel'), 'AgentConnectPanel'),
};
